import { getCurrentDevice } from "main/utils/device";
import { createContext, useContext } from "react";
export const DeviceContext = createContext({
    currentDevice: getCurrentDevice()
});
DeviceContext.displayName = "DeviceContext";
export const useDevice = () => useContext(DeviceContext);
